import { createContext } from "react";
import type useTrialIdentityById from "src/hooks/data/load/useTrialIdentityById";

export interface ITrialIdentityContext extends ReturnType<typeof useTrialIdentityById> {}

export const TrialIdentityContext = createContext<ITrialIdentityContext>({
    data: undefined,
    error: undefined,
    loading: false,
    validating: false,
    mutate: async () => undefined,
    refresh: async () => undefined,
});

export default TrialIdentityContext;
